import 'bootstrap/dist/css/bootstrap.css';
import 'react-tabulator/css/tabulator.min.css';
import 'react-tabulator/css/tabulator_bootstrap5.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import CommServerRoutes from './AppRoutes';
import reportWebVitals from './reportWebVitals';

const element = document.getElementById('root');
if (element === null) throw new Error('Failed to find root element');
const root = ReactDOM.createRoot(element);

root.render(
    <React.StrictMode>
        <CommServerRoutes />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
